export default "/images/arrow-left-circle.svg?8811f7480ff7ba33ca029686a68ef0b2";